import React from "react";

import { Box } from "@material-ui/core";
import { Warning } from "@material-ui/icons";

import Invoice from "./Invoice";

export default function Flag({ children, color = "danger.main" }) {
  return (
    <Box alignItems="center" display="flex" marginBottom={2}>
      <Box color={color} marginRight={1}>
        <Warning color="inherit" />
      </Box>
      {children}
    </Box>
  );
}

Flag.Invoice = Invoice;
